import { useEffect } from "react";
import { QuestionBoxProps } from "./types";
import { Column, Row } from "../../components/containers";
import { JustifyContent } from "../../components/containers/types";
import { Heading } from "../../components/typography";
import { usePopupStore, useThemeStore } from "../../stores";
import { Button } from "../../components/buttons";
import PopupClose from "../popup-close";
import PopupBack from "../popup-back";

const QuestionBox = <T extends {}>({
  question,
  onNo = () => {},
  onYes = () => {},
  back,
  close = true,
}: QuestionBoxProps<T>) => {
  const theme = useThemeStore((s) => s.theme);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxWidth: 600,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const no = (): void => {
    onNo();
    if (close) setPopupBody(null);
  };

  const yes = (): void => {
    onYes();
    if (close) setPopupBody(null);
  };

  return (
    <Column
      justifyContent={JustifyContent.Evenly}
      gap={30}
      style={{ position: "relative" }}
    >
      <PopupClose />
      {back ? (
        <PopupBack Component={back.component} props={back.props} />
      ) : (
        <></>
      )}
      <Heading
        size={18}
        textStyles={{ textAlign: "center", margin: "1rem 2rem" }}
        color={theme.textOnOverlay}
      >
        {question}
      </Heading>
      <Row
        justifyContent={JustifyContent.Evenly}
        gap={10}
        style={{ width: "calc(100% - 4rem)", margin: "1rem 2rem" }}
      >
        <Button background={theme.alert} color={theme.textOnAlert} onClick={no}>
          خیر
        </Button>
        <Button
          background={theme.secondary}
          color={theme.textonSecondary}
          onClick={yes}
        >
          بله
        </Button>
      </Row>
    </Column>
  );
};

export default QuestionBox;
